import http from "../http-common";

class PaymentTypeService {
  getAll() {
    return http.get("/payment-types");
  }

  get(id) {
    return http.get(`/payment-types/${id}`);
  }

  create(data) {
    return http.post("/payment-types", data);
  }

  update(id, data) {
    return http.put(`/payment-types/${id}`, data);
  }

  delete(id) {
    return http.delete(`/payment-types/${id}`);
  }

  getTrashed() {
    return http.get("/payment-types/trashed/list");
  }

  restore(id) {
    return http.post(`/payment-types/${id}/restore`);
  }
}

export default new PaymentTypeService();
